import { ERROR_TYPES } from 'layers/content/constants'

/**
 * Stable lookup key for a row in `curriculumContentManager.content` (Redux state),
 * not a separate HTTP or memory cache.
 */
export function createCurriculumContentStateKey(
  contentGroupCode,
  routePath,
  siteId,
  locale = 'en-US',
) {
  return `${contentGroupCode}::${routePath}::${siteId}::${locale}`
}

const emptySelection = {
  route: null,
  page: null,
  coursePointer: null,
  resolvedInputs: null,
  siteContexts: null,
}

const selectCurriculumContent = (
  contentGroupCode,
  routePath,
  siteId,
  locale = 'en-US',
) => state => {
  try {
    const contentStateKey = createCurriculumContentStateKey(
      contentGroupCode,
      routePath,
      siteId,
      locale,
    )
    const manager = state.curriculumContentManager
    const entry = manager?.content?.[contentStateKey]
    const loading = manager?.isFetching

    if (!entry || !entry.data) {
      return {
        ...emptySelection,
        error: entry?.error
          ? {
              message: entry.error,
              errorType: ERROR_TYPES.contentServiceError,
            }
          : null,
        loading,
      }
    }

    const { data } = entry
    return {
      route: data.route || null,
      page: data.page || null,
      coursePointer: data.coursePointer || data.course_pointer || null,
      resolvedInputs: data.resolvedInputs || null,
      siteContexts: data.siteContexts || null,
      error: null,
      loading: false,
    }
  } catch (cause) {
    return {
      ...emptySelection,
      error: {
        message: cause?.message || 'Curriculum content selection failed',
        errorType: ERROR_TYPES.curriculumContentSelectorError,
      },
      loading: false,
    }
  }
}

export default {
  selectCurriculumContent,
}
